import {FeatureName} from '@contentlab/types/project';

export const ROUTES = {
  CONTENT_LAB: '/content-lab',
  CONTENT_LAB_LOGIN: '/login',
  CONTENT_LAB_SIGNUP: '/signup',
  CONTENT_LAB_PROJECTS: '/projects',
  CONTENT_LAB_PROJECT: '/project',
  CONTENT_LAB_DUB: '/feature/dub',
  CONTENT_LAB_REPHRASE: '/feature/rephrase',
  CONTENT_LAB_RESIZE: '/feature/resize',
  CONTENT_LAB_CAPTIONS: '/feature/captions',
  CONTENT_LAB_AI_AVATAR: '/feature/ai-avatar',
  CONTENT_LAB_UPSCALE: '/feature/upscale',
  CONTENT_LAB_ONBOARDING: '/onboarding',
  CONTENT_LAB_PRICING: '/pricing',
  CONTENT_LAB_PREFERENCES: '/preferences',
  CONTENT_LAB_PREFERENCES_ACCOUNT: '/preferences/account',
  CONTENT_LAB_PREFERENCES_NOTIFICATIONS: '/preferences/notifications',
  CONTENT_LAB_PREFERENCES_TERMS_OF_SERVICE: '/preferences/terms-of-service',
  CONTENT_LAB_ORGANIZATION_SETTINGS: '/organization-settings',
};

export const HIDE_BRAND_HEADER_ROUTES = [
  ROUTES.CONTENT_LAB_PRICING,
  ROUTES.CONTENT_LAB_ONBOARDING,
];

export const HIDE_MENU_ROUTES = [
  ...HIDE_BRAND_HEADER_ROUTES,
  ROUTES.CONTENT_LAB_ONBOARDING,
];

export const CONTENT_LAB_FLOW_ROUTES = {
  [ROUTES.CONTENT_LAB_DUB]: 'dub',
  [ROUTES.CONTENT_LAB_REPHRASE]: 'rephrase',
  [ROUTES.CONTENT_LAB_RESIZE]: 'resize',
  [ROUTES.CONTENT_LAB_CAPTIONS]: 'captions',
  [ROUTES.CONTENT_LAB_AI_AVATAR]: 'ai-avatar',
  [ROUTES.CONTENT_LAB_UPSCALE]: 'upscale',
  [ROUTES.CONTENT_LAB_ONBOARDING]: 'onboarding',
  [ROUTES.CONTENT_LAB_PRICING]: 'pricing',
  [ROUTES.CONTENT_LAB_PROJECTS]: 'projects',
  [ROUTES.CONTENT_LAB_PROJECT]: 'project',
  [ROUTES.CONTENT_LAB_PREFERENCES_ACCOUNT]: 'preferences/account',
  [ROUTES.CONTENT_LAB_PREFERENCES_NOTIFICATIONS]: 'preferences/notifications',
  [ROUTES.CONTENT_LAB_PREFERENCES_TERMS_OF_SERVICE]:
    'preferences/terms-of-service',
  [ROUTES.CONTENT_LAB_PREFERENCES]: 'preferences',
};

// the order matters here as these routes are iterated from top to bottom to find the first match
// we want routes that are more specific to be matched first
export const CONTENT_LAB_ROUTES = {
  ...CONTENT_LAB_FLOW_ROUTES,
  [ROUTES.CONTENT_LAB_PREFERENCES_ACCOUNT]: 'preferences/account',
  [ROUTES.CONTENT_LAB_PREFERENCES_NOTIFICATIONS]: 'preferences/notifications',
  [ROUTES.CONTENT_LAB_PREFERENCES_TERMS_OF_SERVICE]:
    'preferences/terms-of-service',
  [ROUTES.CONTENT_LAB_PREFERENCES]: 'preferences',
  [ROUTES.CONTENT_LAB]: 'homepage',
};

export const FEATURE_TO_ROUTE_MAP: Record<FeatureName, string> = {
  [FeatureName.REFORMATTING]: ROUTES.CONTENT_LAB_RESIZE,
  [FeatureName.AI_DUBBING]: ROUTES.CONTENT_LAB_DUB,
  [FeatureName.REPHRASING]: ROUTES.CONTENT_LAB_REPHRASE,
  [FeatureName.CAPTIONS]: ROUTES.CONTENT_LAB_CAPTIONS,
  [FeatureName.AI_AVATAR]: ROUTES.CONTENT_LAB_AI_AVATAR,
  [FeatureName.UPSCALE]: ROUTES.CONTENT_LAB_UPSCALE,
};
